import _includes from 'lodash/includes';
import Page from './page';
import poll from './poll';
import { nodeChatOnPageValidator } from './node-chat-on-page-validator';
import fireImpressionFptiForChatLoadError from './fire-impression-fpti-for-chat-load-error';

// the Poll function will retry for at least 2 secs based on current retries = 10 and delay = 200 ms
const pollRetries = 10;
const pollDelay = 200;

// eslint-disable-next-line
export const isChatBotCardOrPillPresentOnPage = () => {
  const chatPromptCard = document.getElementById('chat-question-card');
  if (chatPromptCard && chatPromptCard.style.display !== null) {
    return true;
  }

  const chatNowBtn = document.getElementById('chat-now-btn');
  return (chatNowBtn && chatNowBtn.style.display !== null);
};

// Check session for live chat and chat bot clicked event; use remote config to wire on/off
export const isChatByPassEnable = (topicRefId) => {
  const refIdsForChatBot = Page.getRefIdsForChatBot();
  const chatBotClicked = sessionStorage.getItem('chatBotClicked');
  const liveChatClicked = sessionStorage.getItem('liveChatClicked');
  return _includes(refIdsForChatBot, topicRefId) && !chatBotClicked && !liveChatClicked && Page.isLiveChatBypassEnabled();
};


export const getChatAction = (topicRefId) => {
  sessionStorage.setItem('chatCardClicked', 'true'); // Removing chat card after user clicks on live chat since it failed to make users click on it.

  // This bypass is meant to go to the chatBot otherwise it goes to liveChat
  if (isChatByPassEnable(topicRefId)) {
    // When clicked on live chat for the first time opening chatbot making livechatclicked true, to open live chat for the second time
    sessionStorage.setItem('liveChatClicked', 'true');
    // eslint-disable-next-line no-undef

    return poll(nodeChatOnPageValidator, pollRetries, pollDelay)
    // eslint-disable-next-line no-undef
      .then(() => nodeChat.show('chatBot', `${topicRefId}|botOverChat`))
      .catch(() => fireImpressionFptiForChatLoadError('chat-shown'));
  }
  sessionStorage.setItem('liveChatClicked', 'true');

  return poll(nodeChatOnPageValidator, pollRetries, pollDelay)
  // eslint-disable-next-line no-undef
    .then(() => nodeChat.show('liveChat', `${topicRefId}|finalIntent`))
    .catch(() => fireImpressionFptiForChatLoadError('chat-shown'));
};
